import { Link, createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';
import { useDashboardsList } from '@client/lib/dataset-api';
import { PageHeader } from '@client/components/admin/shared';
import { Spinner, EmptyState } from '@client/components/ui/feedback';
import { Badge } from '@client/components/ui/badge';
import { Table, Td, Th, Tr } from '@client/components/ui/table';
import { fmtRelative } from '@client/lib/format';
import { pickLocale } from '@shared/types';

export const Route = createFileRoute('/admin/dashboards/')({ component: DashboardsPage });

function DashboardsPage() {
  const list = useDashboardsList();
  return (
    <>
      <PageHeader title="Dashboards" eyebrow="Built from datasets, published as snapshots" />
      <div className="px-6 py-6 md:px-8">
        {list.isPending ? <Spinner /> : list.data && list.data.dashboards.length === 0 ? (
          <EmptyState icon={BarChart3} title="No dashboards yet" body="Add a dashboard item inside a room (Content tab), then open it here to bind a dataset and build it." />
        ) : (
          <div className="rounded-card border border-border bg-card">
            <Table>
              <thead><tr><Th>Dashboard</Th><Th>Room</Th><Th>Published</Th><Th>Latest version</Th><Th>Updated</Th></tr></thead>
              <tbody>
                {list.data?.dashboards.map((d) => (
                  <Tr key={d.item.id}>
                    <Td><Link to="/admin/dashboards/$itemId" params={{ itemId: d.item.id }} className="font-[520]">{pickLocale(d.item.title, 'en')}</Link></Td>
                    <Td>{d.room ? <Link to="/admin/rooms/$id" params={{ id: d.room.id }} className="text-muted">{d.room.name}</Link> : '—'}</Td>
                    <Td><Badge tone={d.item.status === 'published' ? 'good' : 'neutral'}>{d.item.status}</Badge></Td>
                    <Td>{d.latest ? <>v{d.latest.versionNo} <Badge tone={d.latest.renderStatus === 'ready' ? 'good' : d.latest.renderStatus === 'failed' ? 'critical' : 'warning'}>{d.latest.renderStatus}</Badge></> : <span className="text-muted">none</span>}</Td>
                    <Td className="text-muted">{fmtRelative(d.item.updatedAt, 'en')}</Td>
                  </Tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </>
  );
}
